import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DefaultMoto from '../../../images/default-moto.png';
import { scoreColors } from '../../../helpers/utils';

const ScoreCell = ({
  score,
  photo,
  model,
  hideImage,
  returnAsDiv,
}) => {
  const scoreCellClasses = classNames(`cell-score cell-score--image ${scoreColors(score)}`, { 'cell-score--no-image': hideImage, });
  const scoreContent = (
    <span className="cell__image-score">
      {!hideImage && (
        <div className="cell__image-score__wrapper">
          <img src={photo || DefaultMoto} alt={model} />
        </div>
      )}
      <div className="cell__image-score__number">{score}</div>
    </span>
  );
  const scoreWrapper = (returnAsDiv
    ? <div className={scoreCellClasses}>{scoreContent}</div>
    : <td className={scoreCellClasses}>{scoreContent}</td>
  );

  return scoreWrapper;
};

ScoreCell.propTypes = {
  score: PropTypes.number,
  photo: PropTypes.string,
  // only need to be passed when photo is present
  model: PropTypes.string,
  hideImage: PropTypes.bool,
  returnAsDiv: PropTypes.bool,
};

ScoreCell.defaultProps = {
  score: 0,
  photo: null,
  model: null,
  hideImage: null,
  returnAsDiv: null,
};

export default ScoreCell;
